var template = require('./template');
var updateSelect = function(data){
  var folderSelect = document.getElementById('moveMailToFolder');
  if(folderSelect){
    var opt = document.createElement("option");
    opt.value = data.createFolder.id;
    opt.text = data.createFolder.name;
    opt.selected = true;

    folderSelect.add(opt, null);
    var event = new Event("change", {bubbles:true});
    folderSelect.dispatchEvent(event);
  }
};

var updateDropdown =  function(data){
  var folderDropdown = document.querySelector('.folders');
  if(folderDropdown){
    folderDropdown.classList.remove('hide');
    var list = folderDropdown.querySelector('ul')
    var li = template.populate('customFolderDropdown', {
        text: ['a', 'innerText'],
        url: ['a', 'href']
      }, {
      text: data.createFolder.name,
      url: data.createFolder.url
    });
  list.appendChild(li)
  }
};

module.exports = {
  updateSelect: updateSelect,
  updateDropdown: updateDropdown
}